import { DetectedFile } from "../../types";
import FileDisplay from "../..";

interface FileListProps {
  fileValueWithLinkTypeInfo: {
    value: string;
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    linkTypeInfo?: any;
    detectedFile: DetectedFile | null;
  }[];
  saveData?: (newData: string, previousData: string, index?: number) => void;
  onDeleteFile?: (index: number) => void;
  showDeleteButtons?: boolean;
}

export const FileList = ({
  fileValueWithLinkTypeInfo,
  saveData,
  onDeleteFile,
  showDeleteButtons = false,
}: FileListProps) => (
  <div className="max-h-96 overflow-y-auto">
    <div className="grid grid-cols-3 gap-4">
      {fileValueWithLinkTypeInfo.map(({ value, detectedFile }, index) => (
        <FileDisplay
          // eslint-disable-next-line react/no-array-index-key
          key={index}
          data={value}
          detectedFile={detectedFile}
          saveData={saveData}
          onDelete={onDeleteFile ? () => onDeleteFile(index) : undefined}
          showDeleteButton={showDeleteButtons && onDeleteFile !== undefined}
          isInCollection
        />
      ))}
    </div>
  </div>
);
